import React from 'react';
import { STEPS } from '../CheckoutModal';

const ConfirmAddressStep = ({ state, dispatch, storeData, storeSlug, formatPrice, goToStep, goBack }) => {
  // Serviceability signal only — "we can deliver to this address".
  // The actual cost + method lives on the next step so it can co-exist
  // honestly with free pickup. Showing a shipping cost here anchors
  // the customer to delivery before they've been offered pickup.
  const zoneName = state.shippingCalculation?.zoneName || state.deliveryState;
  const canDeliver = state.shippingCalculation?.canDeliver !== false;

  const handleContinue = () => {
    goToStep(STEPS.DELIVERY_OPTIONS);
  };

  return (
    <div className="cm-step cm-confirm-address-step">
      <div className="cm-address-card">
        <div className="cm-address-card-header">
          <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          <span>Delivery Address</span>
        </div>
        <div className="cm-address-card-body">
          <p className="cm-address-name">{state.fullName}</p>
          <p className="cm-address-line">{state.deliveryAddress}</p>
          {state.deliveryCity && (
            <p className="cm-address-line">{state.deliveryCity}</p>
          )}
          <p className="cm-address-line">{state.deliveryState}</p>
          {state.deliveryCountry && (
            <p className="cm-address-line">{state.deliveryCountry}</p>
          )}
        </div>
      </div>

      {canDeliver ? (
        <div className="cm-serviceability-chip">
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <polyline points="20 6 9 17 4 12" />
          </svg>
          <span>We can deliver to {zoneName || 'this address'} — fulfillment options on the next step.</span>
        </div>
      ) : (
        <div className="cm-serviceability-chip cm-serviceability-chip--unavailable">
          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span>We can't ship to this address. Choose pickup on the next step if available, or update your address.</span>
        </div>
      )}

      <div className="cm-step-footer">
        <button type="button" className="cm-btn cm-btn-secondary" onClick={goBack}>
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Back
        </button>
        <button type="button" className="cm-btn cm-btn-primary" onClick={handleContinue}>
          Continue
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ConfirmAddressStep;
